const PORTAL = {
  root: document.querySelector('body'),
  modal: 'portal-modal',
  dropdown: 'portal-dropdown'
} as const;

export { PORTAL };
